import moment from "moment";

export const StartOfCurrentWeek = moment().startOf('isoWeek').clone();
export const DateFormat = "DD-MM-YYYY";